import React from 'react'
import Header from '../Components/HomePage/Header'
import Kwiatomaty from '../Components/HomePage/Kwiatomaty/Kwiatomaty'
import About from '../Components/HomePage/About'
import GalleryPreview from '../Components/HomePage/GalleryPreview/GalleryPreview'




const HomePage = ({ setPage }) => {
    const today = new Date();
    console.log(today.getMonth());
    console.log(today.getDate());
    let isAnnouncementDay = 1;
    if (today.getFullYear() === 2026 && today.getMonth() >= 2 && today.getDate() >= 11) {
        isAnnouncementDay = 0;
    }


    console.log(isAnnouncementDay);
    return (
        <>
            {isAnnouncementDay && (
                <section className="w-full bg-[#f7f2ec]">
                    <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 gap-10">

                        {/* TEKST */}
                        <div>
                            <p className="text-sm uppercase tracking-widest text-gray-600 mb-3">
                                Drodzy Klienci,
                            </p>

                            <h2 className="text-3xl md:text-4xl font-serif leading-tight mb-4">
                                Zostaliśmy nominowani do konkursu
                                <br />
                                <span className="font-semibold">
                                    „Florysta Roku”
                                </span>{" "}
                                oraz{" "}
                                <span className="font-semibold">
                                    „Kwiaciarnia Roku”
                                </span>
                            </h2>

                            <p className="text-gray-700 mb-4">
                                Już sama nominacja jest dla nas ogromną niespodzianką
                                i zaszczytem. W naszą pracę wkładamy pasję i całe serce.
                            </p>

                            <p className="mb-6 font-medium">
                                Dziękujemy Wam z całego serca ❤️
                            </p>


                        </div>
                        <div className='flex flex-col m-auto gap-6 items-end'>
                            <a
                                href="https://gazetakrakowska.pl/mistrzowie-handlu/pl/2015019/pg/111905"
                                className="px-8 py-3 border border-gray-800 text-gray-800
                                   hover:bg-gray-800 hover:text-white transition"
                            >
                                Głosowanie na Kwiaciarnie Roku
                            </a>
                            <a
                                href="https://gazetakrakowska.pl/mistrzowie-handlu/pl/2014987/pg/111891"
                                className="px-8 py-3 border border-gray-800 text-gray-800
                                   hover:bg-gray-800 hover:text-white transition"
                            >
                                Głosowanie na Floryste Roku
                            </a></div>
                    </div>
                </section>
            )}
            <Header />





            <hr className="my-6 border-gray-300" />
            <Kwiatomaty />

            <hr className="my-6 border-gray-300" />
            <About />

            <hr className="my-6 border-gray-300" />
            <GalleryPreview setPage={setPage} />
        </>
    );
};

export default HomePage